export const STATUS = {
  PENDENTE: 'PENDENTE',
  PROJETADO: 'PROJETADO',
  DESEMBARACADO: 'DESEMBARACADO',  
  LIQUIDADA: 'LIQUIDADA',
};